import React, {PropTypes} from 'react'
import {Modal} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import DieReportForm from './DieReportForm'
import {Form} from 'react-form'
import showToastr from '../../../utils/showToastr'
import validateDieReport from '../../../utils/validateDieReport'
import ErrorHandler from '../../../utils/ErrorHandler'
import './DieReport.css'

class DieReport extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      message: {type: '', context: ''},
      report: {
        horse_id: this.props.horse.id,
        death_date: '',
        death_date_fa: ''
      }
    }
  }

  render () {
    const {message, report} = this.state
    const {toggler, isVisible, horse} = this.props
    const hider = () => {
      toggler(false)
    }
    return (
      <Modal show={isVisible} onHide={hider} bsSize="sm" aria-labelledby="contained-modal-title-sm">
        <Modal.Header>
          <Modal.Title id="contained-modal-title-sm">گزارش مرگ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message.context && <div className={`alert alert-${message.status}`}>{message.context}</div>}
          <Form
            ref="dieForm"
            values={report}
            validate={validateDieReport}
            bornOn={parseInt(horse.born || new Date().getFullYear() - 100, 10)}
            onSubmit={(values) => {
              Actions.horseReportDead(values).then((res) => {
                showToastr('success', 'گزارش مرگ', res.data.messages[0])
                hider()
              }).catch((err) => {
                let eh = new ErrorHandler(err)
                this.setState({message: eh.message, isLoading: false})
                eh.setFormErrors(this.refs.dieForm)
                eh.showToastrIn('گزارش مرگ')
              })
            }}
          >
            {DieReportForm}
          </Form>
        </Modal.Body>
      </Modal>
    )
  }
}

DieReport.propTypes = {
  toggler: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  horse: PropTypes.object.isRequired
}

export default DieReport



// WEBPACK FOOTER //
// ./src/components/HorseInfo/DieReport/DieReport.js